import { get, post, put, patch } from "../../../services/api/Config"

export function SearchExecutives({ params = {}, lang }) {
  return get({ url: `/v1/admin/executives`, params, lang })
}
export function GetExecutivesById({ id, lang }) {
  return get({ url: `/v1/admin/executives/${id}`, lang })
}
export function CreateExecutives({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/executives`, params, data, lang })
}
export function UpdateExecutives({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/executives/${id}`, params, data, lang })
}
export function PatchExecutives({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/executives/${id}`, params, data, lang })
}
export function DeleteExecutives({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/executives/mutiDelete`, params, data, lang })
}
